import { Flex } from 'antd'
import Link from 'next/link'
import React from 'react'
import classnames from 'classnames'
import styles from './MobileBlockHeader.module.scss'

type Props = {
  title: string;
  viewAllTitle: string | null;
  link?: string;
  onClick?: () => void;
  withMargin?: boolean;
}

export function MobileBlockHeader({ title, viewAllTitle, withMargin, link, onClick }: Props) {
  return (
    <div className={classnames(styles.blockHeader, withMargin ? styles.withMargin : '')}>
      <Flex justify="space-between" align="center">
        <p className={styles.blockTitle}>{title}</p>
        {(viewAllTitle && link) && <Link className={styles.accountAll} href={link || '#'}>{viewAllTitle}</Link>}
        {(viewAllTitle && !link) && <span onClick={onClick} className={styles.accountAll}>{viewAllTitle}</span>}
      </Flex>
    </div>
  )
}
